<div *ngIf="pictureField?.length" class="file-card-body form-group">
  <div i18n="@@PictureWithTag">

    {{ title }}

    <button i18n-nbTooltip="@@Upload" (click)="toggleUploader()" nbTooltip="Загрузить" nbButton status="control" style="margin-left: 10px">
      <nb-icon [icon]="addIcon"/>
    </button>

    <a [href]="original" target="_blank" i18n-nbTooltip="@@Delete" nbTooltip="Скачать" *ngIf="fileName" nbButton status="control" style="margin-left: 10px">
      <nb-icon icon="download"/>
    </a>

    <button i18n-nbTooltip="@@Delete" nbTooltip="Удалить фото" (click)="onDeleteConfirm()" *ngIf="picture" nbButton status="control" style="margin-left: 10px" type="button">
      <nb-icon icon="close-outline"/>
    </button>
  </div>

  <div *ngIf="picture || showUploader">
    <img src="{{ fileName }}" alt="" class="picView" *ngIf="fileName"/>

    <form [formGroup]="form" (change)="onSubmit()" *ngIf="showUploader">
      <formly-form [form]="form" [fields]="pictureField" [options]="options" [model]="model"></formly-form>
      <div class="my-drop-zone-info from-parent">
        <ng-content></ng-content>
      </div>
    </form>
  </div>
</div>
